"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferableIdenitytOperator = void 0;
const ethers_1 = require("ethers");
const did_resolver_interface_1 = require("@ew-did-registry/did-resolver-interface");
const did_ethr_resolver_1 = require("@ew-did-registry/did-ethr-resolver");
const OfferableIdentity_json_1 = require("../build/contracts/OfferableIdentity.json");
const ERC1056_json_1 = require("../constants/ERC1056.json");
const { Interface, formatBytes32String } = ethers_1.utils;
const { PublicKey, ServicePoint } = did_resolver_interface_1.DIDAttribute;
class OfferableIdenitytOperator extends did_ethr_resolver_1.Operator {
    /**
     *
     * @param owner - Owner of the identity
     * @param settings - Settings to connect to Ethr registry
     * @param identityAddr - Address of controlled offerable identity
     */
    constructor(owner, settings, identityAddr) {
        super(owner, settings);
        this.identity = new ethers_1.Contract(identityAddr, OfferableIdentity_json_1.abi, owner);
    }
    revokeDelegate() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('Not supported');
        });
    }
    /* eslint-disable @typescript-eslint/no-unused-vars */
    changeOwner(identityDID, newOwnerDid) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('Not supported');
        });
    }
    /* eslint-enable @typescript-eslint/no-unused-vars */
    /**
     * @todo
     */
    deactivate() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('Not supported yet');
        });
    }
    getAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.identity.address;
        });
    }
    offer(offerTo) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.identity.offer(new Interface(OfferableIdentity_json_1.abi).encodeFunctionData('offer', [offerTo]), this.settings.address, 0);
            return true;
        });
    }
    _sendTransaction(method, did, didAttribute, updateData, validity) {
        return __awaiter(this, void 0, void 0, function* () {
            const identity = (0, did_ethr_resolver_1.addressOf)(did);
            const attributeName = this._composeAttributeName(didAttribute, updateData);
            const bytesOfAttribute = formatBytes32String(attributeName);
            const bytesOfValue = (0, did_ethr_resolver_1.hexify)(didAttribute === PublicKey || didAttribute === ServicePoint
                ? updateData.value
                : updateData.delegate);
            const params = [identity, bytesOfAttribute, bytesOfValue];
            if (validity && validity > 0) {
                params.push(validity.toString());
            }
            const data = new Interface(ERC1056_json_1.abi).encodeFunctionData(method, params);
            let receipt;
            try {
                const tx = yield this.identity.sendTransaction(this._contract.address, data, 0);
                receipt = yield tx.wait();
            }
            catch (error) {
                if (error instanceof Error) {
                    throw new Error(error.message);
                }
            }
            return ethers_1.BigNumber.from(receipt.blockNumber);
        });
    }
}
exports.OfferableIdenitytOperator = OfferableIdenitytOperator;
//# sourceMappingURL=offerableIdentityOperator.js.map